// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialog-actions[data-v-d919850e] {\n  display: flex;\n  justify-content: center;\n}\n", ""]);
// Exports
module.exports = exports;
